import { Modal } from '@gerdau/hefesto/Modal';
import React, { useEffect } from 'react';
import { ContactNumber, MessageContainer } from './styles';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../../../../store/ducks/tagging/actions';
import {
  EModalMessageErrorType,
  IOpenOrderData
} from '../../../../../../../../store/ducks/long-steel-orders/types';

interface IWarningCancelOrderModal {
  onClose: () => void;
  order: IOpenOrderData;
  messageType: string;
}

const WarningCancelOrderModal: React.FC<IWarningCancelOrderModal> = ({
  onClose,
  order,
  messageType
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        page: window.location.pathname,
        screenName:
          messageType === EModalMessageErrorType.SHIPMENT
            ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalNaoFoiPossivelCancelarProcessoDeRemessa'
            : 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalNaoFoiPossivelCancelar'
      })
    );
  }, []);

  const handleClose = () => {
    dispatch(
      sendTagging({
        event: 'page_view',
        itemName: 'button:ok',
        itemDescription:
          messageType === EModalMessageErrorType.SHIPMENT
            ? 'meus_pedidos_acosLongos_pedidosAbertos_modalNaoFoiPossivelCancelarProcessoDeRemessa_ok'
            : 'meus_pedidos_acosLongos_pedidosAbertos_modalNaoFoiPossivelCancelar_ok',
        page: window.location.pathname,
        screenName:
          messageType === EModalMessageErrorType.SHIPMENT
            ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalNaoFoiPossivelCancelarProcessoDeRemessa'
            : 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalNaoFoiPossivelCancelar'
      })
    );
    onClose();
  };

  return (
    <Modal
      title="Não foi possível solicitar o cancelamento do item"
      buttons={{
        right: {
          children: 'Ok',
          name: 'fechar-modal',
          onClick: handleClose,
          type: 'button'
        }
      }}
      onClose={handleClose}
    >
      <MessageContainer>
        <span>
          Lamentamos informar que não foi possível solicitar o cancelamento do
          item Nº{order.customerOrder} pelo Gerdau mais, pois{' '}
          {messageType.toLocaleLowerCase()}.
        </span>
        <span>
          Para maiores informações entre contato com a central de atendimento
          através do número:
        </span>
        <ContactNumber>0800 722 3322</ContactNumber>
      </MessageContainer>
    </Modal>
  );
};

export default WarningCancelOrderModal;
